"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SttAlerta;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _SttErrorButton = _interopRequireDefault(require("./SttButton/SttErrorButton"));
var _SttSuccessButton = _interopRequireDefault(require("./SttButton/SttSuccessButton"));
var _SttConfirmationButton = _interopRequireDefault(require("./SttButton/SttConfirmationButton"));
var _SttButton = _interopRequireDefault(require("./SttButton/SttButton"));
var _SttAlertButton = _interopRequireDefault(require("./SttButton/SttAlertButton"));
var _colors = require("@material-ui/core/colors");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    divTitulo: {
      display: 'flex'
    },
    closeButton: function closeButton() {
      return {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.primary.main
      };
    },
    titulo: {
      marginLeft: theme.spacing(2),
      minWidth: '250px'
    },
    conteudo: {
      whiteSpace: 'pre-line'
    },
    blurBackground: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(5px)',
      zIndex: 1200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none'
    }
  };
});
SttAlerta.propTypes = {
  title: _propTypes["default"].string,
  message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  type: _propTypes["default"].string,
  options: _propTypes["default"].array,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  blurBackground: _propTypes["default"].bool
};
function SttAlerta(_ref) {
  var title = _ref.title,
    message = _ref.message,
    type = _ref.type,
    options = _ref.options,
    onClose = _ref.onClose,
    open = _ref.open,
    blurBackground = _ref.blurBackground;
  var theme = (0, _styles.useTheme)();
  var alertTheme = (0, _styles.createTheme)(_objectSpread(_objectSpread({}, theme), {}, {
    palette: {
      primary: _colors.orange
    }
  }));
  var confirmationTheme = (0, _styles.createTheme)(_objectSpread(_objectSpread({}, theme), {}, {
    palette: {
      primary: _colors.blue
    }
  }));
  var successTheme = (0, _styles.createTheme)(_objectSpread(_objectSpread({}, theme), {}, {
    palette: {
      primary: _colors.green
    }
  }));
  var errorTheme = (0, _styles.createTheme)(_objectSpread(_objectSpread({}, theme), {}, {
    palette: {
      primary: _colors.red
    }
  }));
  var temas = {
    'alert': alertTheme,
    'confirmation': confirmationTheme,
    'success': successTheme,
    'error': errorTheme
  };
  var icones = {
    'alert': /*#__PURE__*/_react["default"].createElement(_SttAlertButton["default"], null),
    'confirmation': /*#__PURE__*/_react["default"].createElement(_SttConfirmationButton["default"], null),
    'success': /*#__PURE__*/_react["default"].createElement(_SttSuccessButton["default"], null),
    'error': /*#__PURE__*/_react["default"].createElement(_SttErrorButton["default"], null)
  };
  var classes = useStyles(temas[type]);
  return /*#__PURE__*/_react["default"].createElement(_styles.MuiThemeProvider, {
    theme: temas[type] || successTheme
  }, open && blurBackground && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.blurBackground
  }), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    className: classes.root,
    open: open,
    onClose: onClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    disableTypography: true,
    id: "alert-dialog-title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divTitulo
  }, icones[type], /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h3",
    className: classes.titulo,
    color: "primary"
  }, title), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement(_DialogContentText["default"], {
    className: classes.conteudo,
    id: "alert-dialog-description"
  }, message)), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, index === 0 && /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      onClick: function onClick() {
        option.onClick(option.params);
      },
      variant: "contained",
      color: "primary"
    }, option.title), index !== 0 && /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      onClick: function onClick() {
        option.onClick(option.params);
      },
      variant: option.contained ? "contained" : "outlined",
      color: "primary"
    }, option.title));
  }))));
}